import { ApiError } from '@modules/addresses-store/client/src';

export const isApiError = (response: ApiError | any): response is ApiError => {
  return (response as ApiError)?.code !== undefined;
};

export const isApiErrorBody = (
  response: { body: ApiError } | any
): response is { body: ApiError } => {
  return (response.body as ApiError)?.code !== undefined;
};
